namespace GeniuzPOS.AdvPromo {
    export interface LookupPromoIdRow {
        PmId?: string;
    }

    export namespace LookupPromoIdRow {
        export const idProperty = 'PmId';
        export const nameProperty = 'PmId';
        export const localTextPrefix = 'AdvPromo.LookupPromoId';
        export const lookupKey = 'AdvPromo.LookupPromoId';

        export function getLookup(): Q.Lookup<LookupPromoIdRow> {
            return Q.getLookup<LookupPromoIdRow>('AdvPromo.LookupPromoId');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            PmId = "PmId"
        }
    }
}
